/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2020] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incrporated.
 */

import Cookie from 'js-cookie';

import Config from '../../config/Config';

export default async function ClearAuthenticationCookies() {
  const path = '/';
  const domain = Config.getGatewayCookieDomain();
  const otdsUsernameCookieName = Config.getOTDSUsernameCookieName();
  const otdsTicketCookieName = Config.getOTDSTicketCookieName();
  const samlArtifactCookieName = Config.getSamlArtifactCookieName();
  const checkCookieName = Config.getCheckCookieName();
  return Promise.all([
    Cookie.remove(otdsUsernameCookieName, { path, domain }),
    Cookie.remove(otdsTicketCookieName, { path, domain }),
    Cookie.remove(samlArtifactCookieName, { path, domain }),
    Cookie.remove(checkCookieName, { path, domain })
  ]);
}
